const FETCH_ROLE_CHECKER_REQUEST = 'FETCH_ROLE_CHECKER_REQUEST';
const FETCH_ROLE_CHECKER_SUCCESS = 'FETCH_ROLE_CHECKER_SUCCESS';
const FETCH_ROLE_CHECKER_ERROR = 'FETCH_ROLE_CHECKER_ERROR';
const HIDE_ROLE_CHECKER_LOADER = 'HIDE_ROLE_CHECKER_LOADER';
const SHOW_ROLE_CHECKER_LOADER = 'SHOW_ROLE_CHECKER_LOADER';

// Update Intent Actions
const UPDATE_INTENT_REQUEST = 'UPDATE_INTENT_REQUEST';
const UPDATE_INTENT_SUCCESS = 'UPDATE_INTENT_SUCCESS';
const UPDATE_INTENT_ERROR = 'UPDATE_INTENT_ERROR';

export {
    FETCH_ROLE_CHECKER_REQUEST,
    FETCH_ROLE_CHECKER_SUCCESS,
    FETCH_ROLE_CHECKER_ERROR,
    HIDE_ROLE_CHECKER_LOADER,
    SHOW_ROLE_CHECKER_LOADER,
    UPDATE_INTENT_REQUEST,
    UPDATE_INTENT_SUCCESS,
    UPDATE_INTENT_ERROR,
};
